// @ts-nocheck
export const localeCodes =  [
  "en-gb",
  "fr-fr",
  "nl-nl",
  "it-it",
  "es-es",
  "de-de",
  "pt-pt"
]
export const localeLoaders = {
  "en-gb": [],
  "fr-fr": [],
  "nl-nl": [],
  "it-it": [],
  "es-es": [],
  "de-de": [],
  "pt-pt": []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/e261a716" /* webpackChunkName: "config_i18n_46config_46ts_e261a716" */)
]
export const normalizedLocales = [
  {
    code: "en-gb",
    iso: "en-GB",
    language: "en-GB"
  },
  {
    code: "fr-fr",
    iso: "fr-FR",
    language: "fr-FR"
  },
  {
    code: "nl-nl",
    iso: "nl-NL",
    language: "nl-NL"
  },
  {
    code: "it-it",
    iso: "it-IT",
    language: "it-IT"
  },
  {
    code: "es-es",
    iso: "es-ES",
    language: "es-ES"
  },
  {
    code: "de-de",
    iso: "de-DE",
    language: "de-DE"
  },
  {
    code: "pt-pt",
    iso: "pt-PT",
    language: "pt-PT"
  }
]
/** client **/

/** client-end **/